import { render, staticRenderFns } from "./AparmentDetail.vue?vue&type=template&id=32258cff&scoped=true&"
import script from "./AparmentDetail.vue?vue&type=script&lang=js&"
export * from "./AparmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./AparmentDetail.vue?vue&type=style&index=0&id=32258cff&lang=scss&scoped=true&"
import style1 from "./AparmentDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32258cff",
  null
  
)

export default component.exports